import { useState, useRef } from "react";
import { C } from "../../lib/tokens.js";
import { useClickOutside } from "../../lib/useClickOutside.js";
import { Avatar } from "./Avatar.jsx";

// "Assign / Reassign" button with a searchable agent dropdown. Only picks - the caller
// decides when to save (request edit dialog, afsp.afts project overview).
export function AssigneePicker({ agents, currentId, onSelect, meId, disabled }) {
  const [isOpen, setIsOpen] = useState(false);
  const [search, setSearch] = useState("");
  const ref = useRef(null);

  useClickOutside(ref, isOpen, () => { setIsOpen(false); setSearch(""); });

  // Assigning to yourself is the most common case - list you first so it's a
  // one-click pick instead of scrolling/searching for your own name.
  const orderedAgents = meId
    ? [...agents].sort((a, b) => (a.id === meId ? -1 : b.id === meId ? 1 : 0))
    : agents;

  const filtered = orderedAgents.filter((a) => (a.name || "").toLowerCase().includes(search.trim().toLowerCase()));

  return (
    <div ref={ref} style={{ position: "relative" }}>
      <button
        type="button"
        disabled={disabled}
        onClick={() => setIsOpen((v) => !v)}
        style={{
          display: "inline-flex", alignItems: "center", gap: 4, padding: "3px 8px",
          border: `1px solid ${C.liquid}`, borderRadius: 3, background: C.rowActive,
          color: C.deepsea, fontSize: 11, cursor: disabled ? "default" : "pointer",
          fontFamily: "Roboto", fontWeight: 500, outline: "none",
        }}
      >
        <span className="material-icons" style={{ fontSize: 13 }}>person_add</span>
        {currentId ? "Reassign" : "Assign"}
      </button>

      {isOpen && (
        <div
          style={{
            position: "absolute", top: "100%", right: 0, marginTop: 4,
            background: "#fff", border: `1px solid ${C.mercury}`, borderRadius: 4,
            boxShadow: "0 3px 10px rgba(0,0,0,0.12)", zIndex: 1000, width: 220,
            maxWidth: "calc(100vw - 64px)", padding: "6px 0",
          }}
        >
          <div style={{ padding: "0 8px 6px" }}>
            <input
              autoFocus
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Search agent…"
              style={{
                width: "100%", boxSizing: "border-box", border: `1px solid ${C.mercury}`,
                borderRadius: 3, padding: "5px 7px", fontSize: 12, outline: "none", fontFamily: "Roboto",
              }}
            />
          </div>
          <div style={{ maxHeight: 220, overflowY: "auto" }}>
            {filtered.length === 0 ? (
              <div style={{ padding: "8px 10px", fontSize: 12, color: C.silver, fontStyle: "italic" }}>
                No agents found.
              </div>
            ) : (
              filtered.map((a) => (
                <div
                  key={a.id}
                  onClick={() => { onSelect(a.id); setIsOpen(false); setSearch(""); }}
                  style={{
                    display: "flex", alignItems: "center", gap: 8, padding: "6px 10px",
                    fontSize: 12, color: C.fg, cursor: "pointer",
                    background: a.id === currentId ? C.rowActive : "transparent",
                  }}
                  onMouseEnter={(e) => { if (a.id !== currentId) e.currentTarget.style.background = C.platinum; }}
                  onMouseLeave={(e) => { if (a.id !== currentId) e.currentTarget.style.background = "transparent"; }}
                >
                  <Avatar user={a} size={18} />
                  <span style={{ flex: 1, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{a.name}</span>
                  {a.id === currentId && <span className="material-icons" style={{ fontSize: 12, color: C.liquid }}>check</span>}
                </div>
              ))
            )}
          </div>
        </div>
      )}
    </div>
  );
}
